import {useAppDispatch} from "../../../../../hooks/hooks";
import {useCallback} from "react";
import {VoucherExpirationPutDTO} from "../../../../../types/voucher";
import {updateVoucherExpirationAsync} from "../../../../../store/voucherSlice";

export function useVoucherExpirationActions() {
    const dispatch = useAppDispatch();

    const updateVoucherExpiration = useCallback(
        async (dto: VoucherExpirationPutDTO) => {
            try {
                await dispatch(updateVoucherExpirationAsync(dto)).unwrap();
                alert("이용권 기간 정보가 수정되었습니다.")

            } catch (e) {
                console.error(e);
                throw new Error("getVoucherExpiration occurs an error");
            }
        },
        [dispatch]
    );

    return {
        updateVoucherExpiration
    };
}
